import React, { forwardRef, RefObject } from 'react';
import classNames from 'classnames';

import { StyledComboboxContentFooter } from './styles';
import { ComboboxContentFooterProps } from './types';
import { Comp, getContainerStylingTransientProps } from '@redsift/design-system';

const COMPONENT_NAME = 'ComboboxContentFooter';
const CLASSNAME = 'redsift-combobox-content-footer';

/**
 * The ComboboxContentFooter component.
 */
export const ComboboxContentFooter: Comp<ComboboxContentFooterProps, HTMLDivElement> = forwardRef((props, ref) => {
  const { transientProps, otherProps } = getContainerStylingTransientProps(props);

  const { children, className, ...forwardedProps } = otherProps;

  return (
    <StyledComboboxContentFooter
      {...forwardedProps}
      {...transientProps}
      className={classNames(ComboboxContentFooter.className, className)}
      ref={ref as RefObject<HTMLDivElement>}
    >
      {children}
    </StyledComboboxContentFooter>
  );
});
ComboboxContentFooter.className = CLASSNAME;
ComboboxContentFooter.displayName = COMPONENT_NAME;
